import React from "react";
import star from "../../assets/landingPageItems/star.svg";
import synapsify from "../../assets/landingPageItems/synapsify.svg";
import accountsIncLogo from "../../assets/landingPageItems/accountsIncLogo.svg";
import openInvitationPlatform from "../../assets/landingPageItems/openInvitationPlatform.svg";
import gradient from "../../assets/landingPageItems/gradient.jpg";
const Awards = () => {
  // Determine if screen is less than md using a media query
  const [isMobile, setIsMobile] = React.useState(false);
  const logos = [
    { icon: synapsify, logoName: "Synapsify" },
    { icon: accountsIncLogo, logoName: "Accounts Inc" },
    { icon: openInvitationPlatform, logoName: "Open Invitation Platform" },
  ];

  React.useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 840);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <section className="w-full text-center py-8 md:py-12  bg-lightBlue ">
      <div
        className="w-full mx-auto rounded-2xl bg-indigo-300"
        style={
          !isMobile
            ? {
                backgroundImage: `url(${gradient})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : {
                backgroundImage: "none",
                backgroundColor: "#1A1F71", // fallback to lightBlue
              }
        }
      >
        <div className="py-4 md:py-12 xl:px-16">
          <img
            src={star}
            alt="Logo"
            className="h-[80px] md:h-[100px] select-none mx-auto mb-4"
            draggable="false"
          />
          <h1 className="text-white text-4xl md:text-6xl font-audiowide text-center my-8">
            Award Recognition
          </h1>
          <p className="text-2xl font-semibold text-center text-lightGreen mb-8">
            Finalist in the prestigious Singapore IMDA Open Innovation Challenge
            2024
          </p>
          <div className="flex justify-center items-center gap-8 flex-wrap max-md:hidden">
            {[synapsify, accountsIncLogo, openInvitationPlatform].map(
              (logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt={
                    index === 0
                      ? "Synapsify Logo"
                      : index === 1
                      ? "Accounts Inc Logo"
                      : "Open Invitation Platform Logo"
                  }
                  className={`h-[40px] md:h-[60px] select-none ${
                    index === 2 && "max-md:hidden"
                  }`}
                  draggable="false"
                />
              )
            )}
          </div>
          <div className="md:hidden w-full relative">
            <div className="flex animate-scroll smd:animate-scrollSmd whitespace-nowrap ">
              <div className="flex items-center gap-8 px-4">
                {Array(5)
                  .fill(logos)
                  .flat()
                  .map((logo, i) => (
                    <img
                      src={logo?.icon}
                      alt={logo?.logoName}
                      key={i}
                      className="h-12 w-auto"
                    />
                  ))}
              </div>
            </div>
          </div>
          <div className=" w-full overflow-hidden relative">
            <div className="w-full flex animate-scroll ">
              {/* Duplicated logos for seamless loop */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Awards;
